import { getMaskedPhone, getMaskFromName, Pending } from '@finbeat/react-toolkit';
import { MerchantTradeOrgContact } from 'models/api/merchant';
import { Trans } from 'react-i18next';
import { FaPhone, FaTelegramPlane } from 'react-icons/fa';
import { MdPerson } from 'react-icons/md';
import { UseQueryResult } from 'react-query';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

type MerchantContactsProps = {
    contacts: MerchantTradeOrgContact[];
    getContactsQuery: UseQueryResult<MerchantTradeOrgContact[], unknown>;
};

const MerchantContacts = ({ contacts, getContactsQuery }: MerchantContactsProps) => {
    const orgName = contacts?.length ? contacts[0].tradeOrgName : '';

    return (
        <>
            {getContactsQuery.isFetching && <Pending />}
            {getContactsQuery.isError && (
                <div className="text-center p-3">
                    <Trans i18nKey="BackOfficeCantLoadMerchantContacts" />
                </div>
            )}
            {getContactsQuery.isFetched && (
                <>
                    {contacts.map((item, ids) => {
                        const phoneFormatted = getMaskedPhone(
                            item.phoneNumber,
                            getMaskFromName('Uzbekistan')
                        );

                        return (
                            <>
                                <Card className="mb-3" key={ids}>
                                    <CardHeader>
                                        <h6>Paylater</h6>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className="mb-3">
                                            <Col>
                                                <MdPerson /> {item.name}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col>
                                                <FaPhone /> {phoneFormatted}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <FaTelegramPlane />
                                                &nbsp;
                                                <a
                                                    href={`https://t.me/${item.telegram}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {item.telegram}
                                                </a>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </>
                        );
                    })}
                    {orgName}
                </>
            )}
        </>
    );
};

export default MerchantContacts;
